import { EnergyType } from 'services/api/entities';
import { FormulaFields, KeyQuality, KeyRoot } from './types';

export const NAMESPACE = 'aiMusicGenerator';

export const DEFAULT_FORMULA_VALUES = {
  [FormulaFields.Energy]: EnergyType.ORIGINAL,
  [FormulaFields.Duration]: 120,
  [FormulaFields.Bpm]: 130,
  [FormulaFields.Instruments]: {},
  [FormulaFields.Key]: {
    quality: KeyQuality.MINOR,
    root: KeyRoot.A,
  },
  [FormulaFields.UserLoop]: {
    entropy: 0.2,
  },
};
